import {
  AfterViewInit, Component, createNgModule, Injector, NgModuleRef, OnDestroy, ViewChild, ViewContainerRef
} from '@angular/core';
import { ProductsModule } from '../../../products/products.module';
import { ProductMapComponent } from '../../../products/operative/products-operative-products/components/product-map/product-map.component';

@Component({
  selector: 'app-admin-home-products',
  standalone: false,
  templateUrl: './admin-home-products.component.html',
  styleUrl: './admin-home-products.component.sass'
})
export class AdminHomeProductsComponent implements AfterViewInit, OnDestroy {

  @ViewChild('productMapHost', { read: ViewContainerRef, static: true })
  private productMapHost!: ViewContainerRef;

  private productsModuleRef?: NgModuleRef<ProductsModule>;

  constructor(private injector: Injector) { }

  ngAfterViewInit(): void {
    // ProductMapComponent (and the editors it opens, e.g. ProductsEditComponent) are
    // non-standalone components declared in the lazy-loaded ProductsModule. When this
    // admin home renders <app-product-map> through the admin module scope, ProductsModule's
    // internal directive scope is never flattened, so dynamically created editors fail at
    // runtime with NG0303 ("Can't bind to 'ngIf'"). Creating the component through a
    // ProductsModule NgModuleRef renders it in its own module context, which flattens the
    // module scope for all its declared components (same as visiting the /products route).
    this.productsModuleRef = createNgModule(ProductsModule, this.injector);
    this.productMapHost.createComponent(ProductMapComponent, { ngModuleRef: this.productsModuleRef });
  }

  ngOnDestroy(): void {
    this.productMapHost?.clear();
    this.productsModuleRef?.destroy();
  }
}
